export default __webpack_public_path__ + "static/short-statement-dont-7cbb7a0e55fe65863c3bf96a8f169754.png";